import { AppConfig } from './app-config.model';

export const env: AppConfig = {
    tradgineDataUrl: 'https://data.tradgine.com',
    auctionFlowUrl: 'https://af.tradgine.com',
    auctionSealedFlowUrl: 'https://afs.tradgine.com',
    authUrl: 'https://auth.tradgine.com/api',
    historyUrl: 'https://history.tradgine.com',
    notificationsUrl: 'https://notifications.tradgine.com',
    environment: 'Development',
};
